import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import * as API from 'api';
import * as CONSTANTS from 'constants';
import * as ACTIONS_APP from 'actions/App';
import * as ACTIONS_INPUT_MODULE from 'actions/InputModule';
import { toastManager } from 'components/ToastNotification';

function* requestInputModuleList({ payload }) {
    try {
        yield put(ACTIONS_INPUT_MODULE.setInputModuleList(null));

        const inputmodule = yield call(API.POST, payload.url, payload.data);

        if (!inputmodule?.data?.moduleList) {
            yield put(ACTIONS_INPUT_MODULE.setInputModuleList([]));
        } else {
            yield put(ACTIONS_INPUT_MODULE.setInputModuleList(inputmodule.data.moduleList));
        }
    } catch (error) {
        yield put(ACTIONS_INPUT_MODULE.setInputModuleList([]));
        console.warn(error);
    }
}

function* requestGetInputModule({ payload }) {
    try {
        yield put(ACTIONS_INPUT_MODULE.setInputModuleDetails(null));
        const inputmodule = yield call(API.POST, payload.url, payload.data);

        if (inputmodule?.data) {
            yield put(ACTIONS_INPUT_MODULE.setInputModuleDetails(inputmodule.data));
        } else {
            yield put(ACTIONS_APP.showMessage('notifications.error.failed'));
        }
    } catch (error) {
        yield put(ACTIONS_APP.showMessage('notifications.error.failed'));
        yield put(ACTIONS_INPUT_MODULE.setInputModuleDetails(null));
        console.warn(error);
    }
}

function* requestUpdateInputModule({ payload }) {
    const { nameRequest, detailsRequest } = payload;
    try {
        let moduleList = null;

        // Name and details use different endpoints; run them in order and stop at the first failure
        if (nameRequest) {
            const nameResponse = yield call(API.POST, nameRequest.url, nameRequest.data);
            if (!nameResponse) {
                yield put(ACTIONS_INPUT_MODULE.setInputModuleRequestStatus(CONSTANTS.INPUT_MODULE_REQUEST_FAILURE));
                return;
            }
        }

        if (detailsRequest) {
            const detailsResponse = yield call(API.POST, detailsRequest.url, detailsRequest.data);
            if (!detailsResponse) {
                yield put(ACTIONS_INPUT_MODULE.setInputModuleRequestStatus(CONSTANTS.INPUT_MODULE_REQUEST_FAILURE));
                return;
            }
            moduleList = detailsResponse.data?.moduleList ?? null;
        }

        if (moduleList) {
            yield put(ACTIONS_INPUT_MODULE.setInputModuleList(moduleList));
        } else {
            yield put(ACTIONS_INPUT_MODULE.fetchInputModuleList());
        }
        yield put(ACTIONS_APP.showMessage('notifications.success.edit', 'success'));
        yield put(ACTIONS_INPUT_MODULE.setInputModuleRequestStatus(CONSTANTS.INPUT_MODULE_REQUEST_SUCCESS));
    } catch (error) {
        yield put(ACTIONS_APP.showMessage('notifications.error.failed'));
        yield put(ACTIONS_INPUT_MODULE.setInputModuleRequestStatus(CONSTANTS.INPUT_MODULE_REQUEST_FAILURE));
        console.warn(error);
    }
}

function* requestDeleteInputModule({ payload }) {
    try {
        const response = yield call(API.POST, payload.url, payload.data);

        if (!response) {
            yield put(ACTIONS_INPUT_MODULE.setInputModuleRequestStatus(CONSTANTS.INPUT_MODULE_REQUEST_FAILURE));
            return;
        }

        yield put(ACTIONS_INPUT_MODULE.fetchInputModuleList());
        yield put(ACTIONS_APP.showMessage('notifications.success.delete', 'success'));
        yield put(ACTIONS_INPUT_MODULE.setInputModuleRequestStatus(CONSTANTS.INPUT_MODULE_REQUEST_SUCCESS));
    } catch (error) {
        yield put(ACTIONS_APP.showMessage('notifications.error.fail.noDelete', 'warning'));
        yield put(ACTIONS_INPUT_MODULE.setInputModuleRequestStatus(CONSTANTS.INPUT_MODULE_REQUEST_FAILURE));
        console.warn(error);
    }
}

function* requestSetInputModuleByUnit({ payload }) {
    try {
        const response = yield call(API.POST, payload.url, payload.data);

        if (!response) {
            toastManager.addToast(payload.overwrite.errorMessage);
            return;
        }
        toastManager.addToast(payload.overwrite.successMessage);

    } catch (error) {
        toastManager.addToast(payload.overwrite.errorMessage);
        console.warn(error);
    }
}

function* requestFetchInputModuleTypes({ payload }) {
    try {
        const response = yield call(API.POST, payload.url, payload.data);

        if (!response?.data) {
            yield put(ACTIONS_INPUT_MODULE.setInputModuleTypes([]));
            return;
        }
        yield put(ACTIONS_INPUT_MODULE.setInputModuleTypes(response.data));
    } catch (error) {
        yield put(ACTIONS_INPUT_MODULE.setInputModuleTypes([]));
        console.warn(error);
    }
}

export function* selectFetchInputModuleList() {
    yield takeEvery(CONSTANTS.FETCH_INPUT_MODULE_LIST, requestInputModuleList);
}

export function* selectGetInputModule() {
    yield takeEvery(CONSTANTS.GET_INPUT_MODULE, requestGetInputModule);
}

export function* selectUpdateInputModule() {
    yield takeEvery(CONSTANTS.UPDATE_INPUT_MODULE, requestUpdateInputModule);
}

export function* selectDeleteInputModule() {
    yield takeEvery(CONSTANTS.DELETE_INPUT_MODULE, requestDeleteInputModule);
}

export function* selectSetInputModuleByUnit() {
    yield takeEvery(CONSTANTS.SET_INPUT_MODULE_BY_UNIT, requestSetInputModuleByUnit);
}
export function* selectFetchInputModuleTypes() {
    yield takeEvery(CONSTANTS.FETCH_INPUT_MODULE_TYPES, requestFetchInputModuleTypes);
}

export default function* rootSaga() {
    yield all([
        fork(selectFetchInputModuleList),
        fork(selectGetInputModule),
        fork(selectUpdateInputModule),
        fork(selectDeleteInputModule),
        fork(selectSetInputModuleByUnit),
        fork(selectFetchInputModuleTypes),
    ]);
}
